interface FieldErrorProps {
  message?: string;
}

/** Shared form-field validation error line — one canonical scale (text-sm) across every form dialog. */
export const FieldError = ({ message }: FieldErrorProps) => (message ? <p className="text-sm text-red-500">{message}</p> : null);
FieldError.displayName = 'FieldError';
